import type { FormField } from '@/components/company/FormBuilderWithLayout';

export interface JabatanOption {
  label: string;
  value: string;
}

/**
 * Builds the reward form fields. The "Jabatan" select is only included when the
 * bonus category is "level_jabatan" (it sits right after the category field), so
 * it shows/hides as the user changes the category.
 */
export const buildRewardFields = (category: string | undefined, jabatanOptions: JabatanOption[]): FormField[] => {
  const categoryField: FormField = {
    name: 'category',
    label: 'Kategori Bonus',
    type: 'select',
    options: [
      { label: 'Level Perusahaan', value: 'level_perusahaan' },
      { label: 'Level Jabatan', value: 'level_jabatan' },
    ],
  };

  const jabatanField: FormField = {
    name: 'org_chart_node_id',
    label: 'Jabatan',
    type: 'select',
    required: true,
    placeholder: 'Pilih jabatan',
    options: jabatanOptions,
  };

  const rest: FormField[] = [
    {
      name: 'bonus_name',
      label: 'Nama Bonus',
      type: 'text',
      required: true,
      placeholder: 'contoh: Bonus Tim Konten',
      hint: 'Tentukan nama bonus yang ingin dibuat sesuai dengan tujuan yang ingin dicapai.',
      rules: {
        maxLength: {
          value: 255,
          message: 'Nama Bonus maksimal 255 karakter',
        },
      },
    },
    {
      name: 'bonus_period',
      label: 'Periode Bonus',
      type: 'text',
      required: true,
      placeholder: 'contoh: 6 bulan',
      hint: 'Tentukan durasi waktu pencapaian target bonus (harian, bulanan, tahunan, atau periode khusus).',
      rules: {
        maxLength: {
          value: 255,
          message: 'Periode Bonus maksimal 255 karakter',
        },
      },
    },
    {
      name: 'bonus_target',
      label: 'Target',
      type: 'text',
      required: true,
      placeholder: 'contoh: Mencapai 10.000 followers baru',
      hint: 'Tentukan tujuan yang ingin dicapai: apa yang dicapai, jumlah/angka yang jelas, dan indikator keberhasilan yang bisa diukur.',
      rules: {
        maxLength: {
          value: 500,
          message: 'Target maksimal 500 karakter',
        },
      },
    },
    {
      name: 'bonus_amount',
      label: 'Besaran Bonus',
      type: 'text',
      required: true,
      placeholder: 'contoh: Liburan ke Bali (Non-Tunai)',
      hint: 'Tentukan nilai bonus yang diberikan sesuai dengan kebijakan dan kesepakatan perusahaan (bisa berupa tunai maupun non-tunai).',
      rules: {
        maxLength: {
          value: 500,
          message: 'Besaran Bonus maksimal 500 karakter',
        },
      },
    },
  ];

  return category === 'level_jabatan' ? [categoryField, jabatanField, ...rest] : [categoryField, ...rest];
};
